// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__e7A3U","loaderOuter":"PageOverlayLoader_loaderOuter__244lH"};